import React, { Fragment } from 'react'
import EditBtn from '../../buttons/EditBtn'
import DeleteBtn from '../../buttons/DeleteBtn'
import NullMssg from '../../common/NullMssg'
import SpinnerLoading from '../../common/SpinnerLoading'
import { NoInfo } from '../../common/NoInfo'
import _ from 'lodash'
import { mssgs } from '../../../constantes/mssgs'

const HospitalsList = ({
  filteredHospitales,
  handleRemove,
  toEditHospitals,
  loading,
}) => {
  const sortedHospitales = _.orderBy(filteredHospitales, ['nombre'], ['asc'])

  return (
    <Fragment>
      <div className='table-wrapper'>
        <table className='hospitals-table'>
          <thead>
            <tr>
              <th className="table-th-code">
                Código
              </th>
              <th>
                Nombre
              </th>
              <th>
                Población
              </th>
              <th>
                Comunidad
              </th>
              <th>
                Dirección
              </th>
              <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedHospitales.length > 0 ? (
              sortedHospitales.map((hospital, i) => (
                <tr key={hospital.id_Hospital}>
                  <td>
                    {hospital.codigo}
                  </td>
                  <td className="table-td-header">
                    {hospital.nombre}
                  </td>
                  <td>
                    {hospital.poblacion}
                  </td>
                  <td>
                      {hospital.comunidad_Autonoma
                        ? hospital.comunidad_Autonoma
                        : null}
                      {hospital.pais && hospital.comunidad_Autonoma
                        ? ', '
                        : null}
                        <br />
                      {hospital.pais ? hospital.pais : null}
                  </td>
                  <td>
                    {hospital.direccion
                      ? hospital.direccion
                      : NoInfo('Sin dirección')}
                  </td>
                  <td className="table-td-actions">
                        <button
                          className='action-button'
                          onClick={() => toEditHospitals(hospital.id_Hospital)}
                        >
                          <EditBtn />
                        </button>
                        <button
                          className='action-button'
                          onClick={() => handleRemove(hospital.id_Hospital)}
                        >
                          <DeleteBtn />
                        </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                {loading ? (
                  <td colSpan={6} style={{ width: "100%", textAlign: 'center'}}>
                    <span>
                      <SpinnerLoading loading={loading} size={60} color='#0ca39d' width="100%" />
                    </span>
                  </td>
                ) : (
                  <td colSpan={6}>
                    <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_HOSPITALES} />
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Fragment>
  )
}

export default HospitalsList
